// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1ERSd","label":"SetPasswdForm_label__1cJ_7"};